
















import Vue from 'vue'
import Component from 'vue-class-component'
// store
import moduleStore from './store/VipWechatPay'
// component
import { Toast, Dialog } from 'vant'
// utils
import { isWeiXin } from '@/utils/open-download-app'
// 支付
import LZString from '../../utils/lz-string.min'

@Component({})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames
})
export default class ycdWechatPayMiddle extends Vue {

  // 是/否展示提示步骤
  isStepVisible: boolean = false

  // 定时器
  timeout = null

  // 来源页面
  fromPage: string | null = null

  // 支付方式
  payType: string | null = null

  // 订单信息
  info: any = {}

  /****************************** 生命周期函数 ******************************/

  created() {

  }

  mounted() {
    // 支付方式
    this.payType = this.$route.query.payType as string
    // 来源
		this.fromPage = this.$route.query.from as string

    if (this.fromPage === 'ycdPayment') {
			const info = LZString.decompressFromBase64(this.$route.query.info as any)
      this.info = JSON.parse(info)
			console.log('mounted', this.$route.query, this.fromPage, this.info)
		} 

    if (isWeiXin()) {
      // 微信内部浏览器
			this.isStepVisible = true
      // 轮询，定时请求支付状态
			setTimeout(() => {
				this.poll()
			}, 3500)
    } else {
      // 外部浏览器
			if (this.payType === 'wxpayH5') {
				// h5 调起微信支付逻辑 - 微信返回的url
				const formVal = this.info.mweb_url
        // 重定向回来的 url
				const redirect_url = encodeURIComponent(`${ window.location.origin }/#/ycd-payment-success?orderId=${ this.info.orderId }`)
        // 重定向
				const form = document.createElement('form')
				document.body.appendChild(form)
				form.method = "post"
				form.action = `${ formVal }&redirect_url=${ redirect_url }`
				form.submit()
				document.body.removeChild(form)
			}
    }
  }

  beforeDestroy() {
    // 清除定时器
    this.timeout && clearTimeout(this.timeout)
    // 初始化定时器对象
    this.timeout = null
  }

  /****************************** 查询支付状态 ******************************/
  
  poll() {
    this.timeout = setTimeout(() => {
      this.getYcdPaymentStatus(true, {
        success: () => {
          // 清除定时器
          this.timeout && clearTimeout(this.timeout)
        },
        other: () => {
          this.poll()
        }
      })
    }, 3000)
  }

  /** 获取支付状态 */
  getYcdPaymentStatus(isPoll = false, callback = {}) {

    const { success, failed, other } = callback as any

		const { orderId } = this.info

    console.log('getYcdPayStatusInfo', orderId)

    this.$http('getYcdPayStatusInfo', { orderId })
      .then(res => {
        const { code, data } = res
        if (code === 200) {
          
          switch(data.status) {
            case '支付成功':
              // 成功回调函数
              success && success()
              // 成功确认弹窗
              Dialog.confirm({
                title: '支付成功',
                message: '订单支付成功，前往小程序体验',
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                className: "confirm-dialog",
              })
                .then(() => {
                  window.location.href = '/toYcdWechat.html'
                })
              break
            case '已创建':
              other && other()
              if (!isPoll) {
                // 失败回调函数
                failed && failed()
                // 失败确认弹窗
                Dialog.confirm({
                  title: '支付失败！',
                  message: '订单支付失败，请继续支付',
                  confirmButtonText: '确认',
                  cancelButtonText: '取消',
                  className: "confirm-dialog",
                })
              }
              break
          }
        }
      })
  }

}
